import {UserRankHistoryDomain} from "../../domain/user/UserRankHistoryDomain"
import {AssetLunarUsageId} from "../../id/asset/AssetLunarUsageId"
import {AssetSolarUsageId} from "../../id/asset/AssetSolarUsageId"
import {AssetStarUsageId} from "../../id/asset/AssetStarUsageId"
import {UserId} from "../../id/user/UserId"
import {UserRankHistoryId} from "../../id/user/UserRankHistoryId"
import {UserRankId} from "../../id/user/UserRankId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 사용자 랭크 기록
 */
export class UserRankHistoryValueObject implements ValueObject, UserRankHistoryDomain {
    /**
     * 기본키
     */
    id: UserRankHistoryId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 사용자 랭크 ID
     */
    userRankId: UserRankId
    /**
     * 루나 지급 ID
     */
    assetLunarUsageId?: AssetLunarUsageId
    /**
     * 솔라 지급 ID
     */
    assetSolarUsageId?: AssetSolarUsageId
    /**
     * 스타 지급 ID
     */
    assetStarUsageId?: AssetStarUsageId
    /**
     * 생성일
     */
    createdAt: Date

    constructor(o: Record<keyof UserRankHistoryDomain, any>) {
        this.id = BigInt(o.id)
        this.userId = BigInt(o.userId)
        this.userRankId = BigInt(o.userRankId)
        if (o.assetLunarUsageId !== undefined && o.assetLunarUsageId !== null) {
            this.assetLunarUsageId = BigInt(o.assetLunarUsageId)
        }
        if (o.assetSolarUsageId !== undefined && o.assetSolarUsageId !== null) {
            this.assetSolarUsageId = BigInt(o.assetSolarUsageId)
        }
        if (o.assetStarUsageId !== undefined && o.assetStarUsageId !== null) {
            this.assetStarUsageId = BigInt(o.assetStarUsageId)
        }
        this.createdAt = new Date(o.createdAt)
    }
}
